import { Component, inject, input } from '@angular/core';
import { AufgabenTyp, AufgabeVersandTaetigkeit, AufgabeZertifikatTaetigkeit } from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '../../create-aufgabe-dialog/create-aufgabe.formservice';

type AllowedAufgabenTyp = AufgabenTyp.SCHIFFSBRIEF | AufgabenTyp.SCHIFFSZERTIFIKAT | AufgabenTyp.ZERTIFIKAT;

@Component({
	selector: 'schir-int-client-aufgabe-zertifikat-editor',
	templateUrl: './aufgabe-zertifikat-editor.component.html',
	styleUrls: ['./aufgabe-zertifikat-editor.component.scss'],
	standalone: false,
})
export class AufgabeZertifikatEditorComponent {
	private formService = inject(CreateAufgabeFormService);

	readonly aufgabenTyp = input.required<AllowedAufgabenTyp>();
	readonly excludeEingetragenerEigentuemer = input(true);

	protected readonly taetigkeiten = AufgabeZertifikatTaetigkeit;
	protected readonly versandTaetigkeit = AufgabeVersandTaetigkeit;

	get formGroup() {
		return this.formService.form.controls[this.aufgabenTyp()];
	}

	get bodyControls() {
		return this.formGroup.controls.body.controls;
	}

	toggleTaetigkeitAndSendenControls(taetigkeit: AufgabeZertifikatTaetigkeit) {
		if (taetigkeit === AufgabeZertifikatTaetigkeit.NOTIZ) {
			this.bodyControls.versandTaetigkeit.disable();
			this.bodyControls.sendenAn.disable();
		} else {
			this.bodyControls.versandTaetigkeit.enable();
			this.bodyControls.sendenAn.enable();
		}
	}
}
